export default "__VITE_PUBLIC_ASSET__59d9e95b__"